import { Injectable, NgZone } from "@angular/core";
import { BackgroundMode } from "@ionic-native/background-mode";
import { APIServiceProvider } from "./api.service";
import { Platform } from "ionic-angular";
import { SqlLiteService } from "./sqllite.service";
import { Geolocation, Geoposition } from "@ionic-native/geolocation";

import "rxjs/add/operator/filter";
import { Observable } from "rxjs/Observable";

import { BackgroundGeolocation } from "@ionic-native/background-geolocation";
import "rxjs/add/operator/map";

@Injectable()
export class LocationTracker {
	public watch: any;

	public lat: any = null;
	public lng: any = null;
	originalCoords: any = {
		latitude: null,
		longitude: null
	};
	DISTANCE_TO_MOVE = 0.003069; //0.003 km
	apiUrl: any = "http://35.200.181.245:8082/topics/geodata";

	constructor(
		public zone: NgZone,
		public platform: Platform,
		public sqlLiteService: SqlLiteService,
		public geolocation: Geolocation,
		public backgroundGeolocation: BackgroundGeolocation,
		public apiService: APIServiceProvider,
		public backgroundMode: BackgroundMode
	) {}

	minIntervalObj: any;
	maxIntervalObj: any;

	timerInterval: any;

	// 3 minutes
	pushApiTime: any = 30000;

	// 15 seconds
	watchLocationTime: any = 6000;

	startTracking() {
		if (!this.platform.is("cordova")) {
			return false;
		}
		console.log("startTracking");

		this.backgroundMode.on("activate").subscribe(() => {
			this.backgroundMode.disableWebViewOptimizations();
			console.log("In Background");
		});

		this.backgroundMode.enable();

		Observable.interval(this.watchLocationTime).subscribe(val => {
			this.trackPosition();
		});

		Observable.interval(this.pushApiTime).subscribe(val => {
			this.getAndSave();
		});
	}

	trackPosition = () => {
		this.geolocation
			.getCurrentPosition()
			.then(position => {
				this.zone.run(() => {
					this.lat = position.coords.latitude;
					this.lng = position.coords.longitude;

					this.saveToSqLite(this.lat, this.lng);
				});
			})
			.catch(error => {
				console.log("error", error);
			});
	};

	watchLocation() {
		let options = {
			frequency: this.watchLocationTime,
			enableHighAccuracy: true
		};

		this.watch = this.geolocation
			.watchPosition(options)
			.filter((p: any) => p.code === undefined)
			.subscribe((position: Geoposition) => {
				// Run update inside of Angular's zone
				this.zone.run(() => {
					this.lat = position.coords.latitude;
					this.lng = position.coords.longitude;

					this.saveToSqLite(this.lat, this.lng);
				});
			});
	}

	saveToSqLite(latitude, longitude) {
		this.sqlLiteService.addOrordinates(latitude, longitude, function(
			response
		) {
			console.log("coordinates added Time: " + new Date());
		});
	}

	getAndSave() {
		console.log("MAKING API CALL");
		let self = this;
		this.sqlLiteService.getCoordinatesItem(function(response) {
			var listCopy = Object.assign([], response);

			if (response.length > 0) {
				self.sendToAPI(listCopy, self);
			}
		});
	}

	sendToAPI(postData, self) {
		self.apiService.sendToKafka(self.apiUrl, postData).subscribe(
			response => {
				self.sqlLiteService.removeCoordinates(function(response) {
					console.log("Removed Coordinates");
				});
			},
			error => {
				console.log("Error in pushing the data to API for location");
			}
		);
	}

	stopTracking() {
		console.log("stopTracking");

		this.backgroundGeolocation.finish();
		this.watch.unsubscribe();
	}
}



// WEBPACK FOOTER //
// ./src/common/services/location-tracker.ts